export const mealCategory = [
  {
    id: 1,
    categoryName: '과일',
  },
  {
    id: 2,
    categoryName: '채소',
  },
  {
    id: 3,
    categoryName: '한식',
  },
  {
    id: 4,
    categoryName: '중식',
  },
  {
    id: 5,
    categoryName: '양식',
  },
  {
    id: 6,
    categoryName: '일식',
  },
  {
    id: 7,
    categoryName: '간식',
  },
  {
    id: 8,
    categoryName: '음료',
  },
  {
    id: 9,
    categoryName: '유제품',
  },
  {
    id: 10,
    categoryName: '해산물',
  },
  {
    id: 11,
    categoryName: '고기류',
  },
  {
    id: 12,
    categoryName: '아시안음식',
  },
  {
    id: 13,
    categoryName: '가공식품',
  },
  {
    id: 14,
    categoryName: '식재료',
  },
  {
    id: 15,
    categoryName: '기타',
  },
]
